module.exports = __webpack_public_path__ + "img/payment-white.22642999.svg";